import React, { useState, useEffect } from 'react';
import HeaderGifts from 'newPages/Header';
import { HeaderCompleto } from './Content/pages/HeaderNavegacion';
import { HeaderSimple } from './Content/pages/HeaderSimple';
import { HeaderCaja } from './Content/pages/HeaderCaja';
import { ErrorBoundary } from './Content/components/Error/ErrorBoundary';
import { useValidateSession } from './Content/hooks/token/useValidateSession';
import { usePixeles } from './Content/hooks/usePixeles'
import { useStorage64 } from './Content/hooks/useStorageBase64';

export function Header(props) {
    const { type, pageClass = 'hidden', rute, title = '', hide = false } = props;
    const { session } = useValidateSession()
    const [isLoged] = useStorage64('session_token', '');

    const [upCP, setUpCP] = useState();
    useEffect(() => {}, [upCP]);


    //console.log("llamadao a meta desde header **************** ")
    usePixeles('event_home', '');

    return (
        session || isLoged
            ?
                <HeaderGifts />
            :
                <div className="sears-theme">
                    {type === 'complete' ? (
                        <ErrorBoundary>
                            <HeaderCompleto
                                setUpCP={setUpCP}
                                changeDirectionBar={setUpCP}
                                hide={hide}
                            />
                        </ErrorBoundary>
                        ) : type === 'cart' ? (
                            <ErrorBoundary>
                                <HeaderCaja rute={rute} title={title} />
                            </ErrorBoundary>
                        ) : type === 'simple' ? (
                            <ErrorBoundary>
                                <HeaderSimple pageClass={pageClass} />
                            </ErrorBoundary>
                    ) : null}
                </div>
    );
}
